import DeviceStatus from './DeviceStatus';

export default DeviceStatus;
